import { type ComponentType, memo } from 'react';

import { FilterLogicSelect } from '~/components/Filters/FilterLogicSelect';
import { type PrivateTagsSelectProps } from '~/components/Tags/PrivateTagsSelect';
import { type TagBase } from '~/components/Tags/utils';
import { type FilterLogicType } from '~/store/filters/types';

export type TagsFilterProps = {
  TagsSelect: ComponentType<PrivateTagsSelectProps>;
  selectedLogic: FilterLogicType;
  selectedTags: TagBase[];
  onLogicChange: (logic: FilterLogicType) => void;
  onSelectedTagsChanged: (tags: TagBase[]) => void;
};

export const TagsFilter = memo(
  ({ TagsSelect, onLogicChange, onSelectedTagsChanged, selectedTags, selectedLogic }: TagsFilterProps) => {
    return (
      <div className="flex flex-col items-start">
        <TagsSelect
          className="order-2 w-full"
          selectedTags={selectedTags}
          onSelectedTagsChanged={onSelectedTagsChanged}
          canCreateNewTags
        />
        <FilterLogicSelect className="order-1" selectedLogic={selectedLogic} onLogicChange={onLogicChange} />
      </div>
    );
  },
);

TagsFilter.displayName = 'TagsFilter';
